import type { ToastNotificationState } from 'hooks/useToastNotifications';
import { DEFAULT_LOCALE_INFO } from 'lib/constants/siteDefaults';
import type { FullscreenPopupVariant } from 'types/cms/Globals';
import type { SiteLocale } from 'types/localisation/SiteLocale';

import { ONE_WEEK_MS, THIRTY_DAYS_MS } from './constants';
import type { StorageConfig } from './types';

export const FullscreenPopup = {
  name: 'fullscreenPopup',
  version: 1,
  expirationMillis: ONE_WEEK_MS,
  defaultValue: [],
} as StorageConfig<FullscreenPopupVariant[]>;

export const Callout = {
  name: 'callout',
  version: 1,
  expirationMillis: THIRTY_DAYS_MS,
  defaultValue: false,
} as StorageConfig<boolean>;

export const UserLocale = {
  name: 'userLocale',
  version: 0,
  expirationMillis: THIRTY_DAYS_MS,
  defaultValue: DEFAULT_LOCALE_INFO,
} as StorageConfig<SiteLocale>;

export const UserLocalePreference = {
  name: 'userLocalePreference',
  version: 0,
  expirationMillis: THIRTY_DAYS_MS,
  defaultValue: { hasSetLocale: false },
} as StorageConfig<{ hasSetLocale: boolean }>;

export const CookiebotDeclined = {
  name: 'cookiebotDeclined',
  version: 0,
  expirationMillis: THIRTY_DAYS_MS,
  defaultValue: null,
} as StorageConfig<string | null>;

export const ToastNotifications = {
  name: 'toastNotifications',
  version: 0,
  expirationMillis: THIRTY_DAYS_MS,
  defaultValue: {},
} as StorageConfig<Record<string, ToastNotificationState>>;

export const LongevityMonth = {
  name: 'longevityMonthPopupViewed',
  version: 0,
  expirationMillis: THIRTY_DAYS_MS,
  defaultValue: false,
} as StorageConfig<boolean>;

export const ReviewVote = {
  name: 'productReviewVotes',
  version: 0,
  expirationMillis: THIRTY_DAYS_MS,
  defaultValue: {},
} as StorageConfig<Record<string, { up?: boolean; down?: boolean }>>;

export const Cart = {
  name: 'cart',
  version: 0,
  expirationMillis: THIRTY_DAYS_MS,
  defaultValue: {},
} as StorageConfig<{ id?: string }>;
